/** @return {array} */
export default function getPropertyPhotos(property) {
  return property.media
    .filter((media) => media.order !== 0 && media.image_size_description === 'Largest')
    // Display in numerical order (left>right) starting with photo 1
    .sort((a, b) => a.order - b.order);
}
